import type { IconProps } from './types/types';

const BubbleIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8327 8.08341C20.8327 11.9955 17.6614 15.1668 13.7494 15.1668C9.83742 15.1668 6.66614 11.9955 6.66614 8.08341C6.66614 4.17135 9.83742 1 13.7494 1C17.6614 1 20.8327 4.17135 20.8327 8.08341ZM9.49992 22.2523C9.49992 24.5995 7.59715 26.5024 5.24996 26.5024C2.90277 26.5024 1 24.5995 1 22.2523C1 19.9051 2.90277 18.0023 5.24996 18.0023C7.59715 18.0023 9.49992 19.9051 9.49992 22.2523ZM25.0832 35C30.56 35 34.9998 30.5601 34.9998 25.0832C34.9998 19.6063 30.56 15.1664 25.0832 15.1664C19.6064 15.1664 15.1666 19.6063 15.1666 25.0832C15.1666 30.5601 19.6064 35 25.0832 35Z"
      />
    </svg>
  );
};
export default BubbleIcon;
